module.exports = "{{localize 'CORE.GRID.NOCOLUMNSVIEW.ALLCOLUMNSHIDDEN'}}";


//////////////////
// WEBPACK FOOTER
// ../src/list/templates/noColumns.hbs
// module id = 710
// module chunks = 0